import { Avatar, SvgIcon, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { StyledLink } from "./CustomMUI";
import { ReactComponent as CurateIcon } from "../assets/IconCurate.svg";
import { useThemeContext } from "../context/themeContext.js";

const CURATE_USERNAME = "curate";

/**
 * Renders a user identity as an avatar (or the Curate logo) alongside a name.
 * Pass username="curate" to display the CurateHQ branding instead of a user avatar.
 */
export default function UserChip({
  username,
  avatarUrl,
  size = 22,
  interactive = true,
  color = "inherit",
  showAvatar = true,
}) {
  const { isTouchDevice } = useThemeContext();
  const isCurate = username === CURATE_USERNAME;
  const displayName = isCurate
    ? "Curate"
    : interactive
      ? `@${username}`
      : username;
  const profilePath = isCurate ? null : `/u/${username}`;

  const avatarNode = isCurate ? (
    <SvgIcon sx={{ fontSize: size, p: "3px", color }}>
      <CurateIcon />
    </SvgIcon>
  ) : (
    <Avatar
      src={avatarUrl}
      alt={username}
      imgProps={{ referrerPolicy: "no-referrer" }}
      sx={{ width: size, height: size }}
    />
  );

  const nameNode = (
    <Typography variant="body2" color={color}>
      {displayName}
    </Typography>
  );

  if (!interactive || isCurate) {
    return (
      <>
        {showAvatar && avatarNode}
        {nameNode}
      </>
    );
  }

  return (
    <>
      {showAvatar && (
        <RouterLink to={profilePath} style={{ textDecoration: "none" }}>
          {avatarNode}
        </RouterLink>
      )}
      <StyledLink
        variant="body2"
        component={RouterLink}
        to={profilePath}
        sx={{
          color,
          textDecoration: isTouchDevice ? "underline" : undefined,
        }}
      >
        {displayName}
      </StyledLink>
    </>
  );
}
